module.exports = __webpack_public_path__ + "assets/img/img44.7f888e41.png";